import { render, staticRenderFns } from "./header-notice.vue?vue&type=template&id=08cbb021&"
import script from "./header-notice.vue?vue&type=script&lang=js&"
export * from "./header-notice.vue?vue&type=script&lang=js&"
import style0 from "./header-notice.vue?vue&type=style&index=0&id=08cbb021&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports